(() => {
  const configElement = document.getElementById('SsCannonballTerritory');
  if (!configElement) return;
  const config = JSON.parse(configElement.textContent);
  const root = document.documentElement;
  const allowed = new Set(config.countries);
  const itemSelector = '.product-grid__item,.resource-list__item,.mega-menu__content-list-item,.menu-list__list-item,.menu-drawer__list-item';
  const markLinks = (scope) => {
    for (const link of scope.querySelectorAll('a[href]')) {
      let url;
      try { url = new URL(link.getAttribute('href'), location.origin); } catch { continue; }
      if (url.hostname !== location.hostname || !url.pathname.toLowerCase().includes('cannonball')) continue;
      const container = link.closest('product-card,.resource-card,.collection-card,.ss-home-path') || link.closest(itemSelector) || link;
      if (!container.hasAttribute('data-ss-cannonball-hidden')) container.setAttribute('data-ss-cannonball-hidden', '');
    }
    for (const resource of scope.querySelectorAll('[data-ss-cannonball]')) {
      const item = resource.closest('.product-grid__item,.resource-list__item,.mega-menu__content-list-item');
      if (item && !item.hasAttribute('data-ss-cannonball-hidden')) item.setAttribute('data-ss-cannonball-hidden', '');
    }
  };
  markLinks(document);
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;
        markLinks(node.parentElement || node);
      }
    }
  });
  observer.observe(document.body, { childList:true, subtree:true });
  if (config.designMode) {
    root.dataset.ssCannonballAccess = 'allowed';
    return;
  }
  const check = async () => {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 5000);
    try {
      const base = config.root.endsWith('/') ? config.root : `${config.root}/`;
      const response = await fetch(`${base}browsing_context_suggestions.json?country[enabled]=true&language[enabled]=false`, { credentials:'same-origin', cache:'no-store', signal:controller.signal });
      if (!response.ok) throw new Error('Country detection failed');
      const data = await response.json();
      const country = data.detected_values?.country?.handle;
      if (typeof country !== 'string' || !/^[A-Z]{2}$/.test(country)) throw new Error('Country missing');
      root.dataset.ssCannonballAccess = allowed.has(country) ? 'allowed' : 'denied';
    } catch {
      root.dataset.ssCannonballAccess = 'unavailable';
    } finally {
      clearTimeout(timeout);
    }
  };
  check();
  window.addEventListener('pageshow', (event) => { if (event.persisted) { delete root.dataset.ssCannonballAccess; check(); } });
})();
